module.exports = __webpack_public_path__ + "static/homeVideoMp4-11579ab12de90d08de1dee74aaef5d84.mp4";